import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { libraryShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { Link } from '@bibliocommons/base-links';
import { fixedEncodeURIComponent } from '@bibliocommons/utils-browser';

import './ExternalSearchPanel.scss';

export function ExternalSearchPanel({ currentLibrary, catalogBib }) {
  const intl = useIntl();
  const showProbesOnBib = currentLibrary.get('showProbesOnBib');
  const showExternalSearchLink = currentLibrary.get('showExternalSearchLink');
  const externalSearchLinkTitle = currentLibrary.getIn(['externalSearch', 'externalSearchLinkTitle']) || '';
  const externalSearchLinkTitleWithAuthor =
    currentLibrary.getIn(['externalSearch', 'externalSearchLinkTitleWithAuthor']) || '';

  function getExternalSearchUrl() {
    if (showExternalSearchLink && externalSearchLinkTitleWithAuthor && !showProbesOnBib) {
      const author = catalogBib.getIn(['brief', 'creators', 0, 'searchQuery']);
      const title = catalogBib.getIn(['brief', 'title']);
      return author
        ? externalSearchLinkTitleWithAuthor
            .replace('{t}', fixedEncodeURIComponent(title))
            .replace('{a}', fixedEncodeURIComponent(author))
        : externalSearchLinkTitle.replace('{q}', fixedEncodeURIComponent(title));
    }

    return null;
  }

  const externalSearchUrl = getExternalSearchUrl();
  if (externalSearchUrl) {
    const externalSearchLinkText =
      currentLibrary.getIn(['externalSearch', 'nearbyLibrariesViaExternalSearchLink']) ||
      intl.formatMessage({ id: 'external_search_link' });

    return (
      <div className="cp-external-search-link-panel">
        <div className="external-search-link-panel__text">
          <FormattedMessage id="find_this_title_on" />
        </div>
        <Link className="external-search-link" href={externalSearchUrl} dataKey="external-search-link">
          {externalSearchLinkText}
        </Link>
      </div>
    );
  }

  return null;
}

ExternalSearchPanel.propTypes = {
  currentLibrary: libraryShape.isRequired,
  catalogBib: catalogBibShape.isRequired
};

export default ExternalSearchPanel;
